import { getServerTime } from './tokenRefreshScheduler.js';
function b64DecodeUnicode(str) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(atob(str.replace(/-/g, '+').replace(/_/g, '/').replace(/\s/g, ''))
        .split('')
        .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    })
        .join(''));
}
export function parseJwt(jwt) {
    try {
        const [headerStr, payloadStr /* , signature */] = jwt.split('.');
        const header = JSON.parse(b64DecodeUnicode(headerStr));
        const payload = JSON.parse(b64DecodeUnicode(payloadStr));
        return {
            header,
            payload,
        };
    }
    catch (e) {
        console.error('Invalid JWT token:', jwt, e);
        return null;
    }
}
export function isActiveJwt(jwt) {
    return jwt?.payload.exp && jwt.payload.exp * 1000 > getServerTime();
}
//# sourceMappingURL=utils.js.map